import React, { FC } from 'react';

import Container from '../components/Container';
import ModalWalletDetail from '../components/ModalWalletDetail';

const SceneError: FC = () => {
  React.useEffect(() => {
    setInterval(() => {
      window.location.replace(`/bridge`);
    }, 5000);
  }, []);

  return (
    <>
      <Container>
        <div className="bridge-explorer wow fadeIn fast">
          <i className="icon icon-4x icon-message" />
          <h4 style={{ marginTop: 6 }}>Page Not Found</h4>
          <p>Returning to homepage after a while.</p>
        </div>
      </Container>
      <ModalWalletDetail />
    </>
  );
};

export default SceneError;
